<template>
  <div class="sample-input-main">
		<Input class="my-input" :placeholder="myPlaceholder" :textAlign="myTextAlign" :textType="myTextType" :inputValue.sync="myValue"
			:isDisabled="myTextDisabled" @enter="enterClicked" @focusIn="focusChanged(true)" @focusOut="focusChanged(false)" ref="myInput"/>

		<Input placeholder="Select Image" textType="file" fileType="image/*" :multiFile="true" @fileChanged="fileChanged"/>
		<Input placeholder="Select Image 2" textType="file" fileType="image/*" :multiFile="true" @fileChanged="fileChanged2"/>

		<img :src="`data:image/jpg;base64, ${img1}`" height="100" width="100">
		<img :src="`data:image/jpg;base64, ${img2}`" height="100" width="100">

		<button @click="getImage('1')">Image 1</button>
		<button @click="getImage('2')">Image 2</button>

		<div style="display: flex; margin: 10px 0; align-items: flex-end">
			<Input placeholder="Input" textAlign="right" :isRequired="true"/>
			<Dropdown placeholder="Dropdown"/>
		</div>
		<div style="display: flex">
			<button style="margin: 0 5px" @click="toggleTextAlign()">Toggle TextAlign</button>
			<button style="margin: 0 5px" @click="toggleTextType()">Toggle TextType</button>
			<button style="margin: 0 5px" @click="setValue()">Set Input Value</button>
			<button style="margin: 0 5px" @click="toggleDisable()">Toggle Disable</button>
			<button style="margin: 0 5px" @click="setFocusToInput()">Set Focus</button>
		</div>
		<br>
		<div>placeholder : {{ myPlaceholder }}</div>
		<div>textAlign : {{ myTextAlign }}</div>
		<div>textType : {{ myTextType }}</div>
		<div>inputValue : {{ myValue }}</div>
		<div>isDisabled : {{ myTextDisabled }}</div>
		<div>@enter : {{ enterCount }} times pressed</div>
		<div>@focusIn / @focusOut : input is {{ focusStatus }}</div>

		<Input textType="imageUpload" placeholder="Profile Picture"/>

		<div style="margin-bottom: 250px"></div>
	</div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import Dropdown from '@/components/Dropdown.vue';

export default {
  components: {
		Input, Dropdown
	},
	props: {
		myPlaceholder: { type: String, default: 'Test' },
		myTextAlign: { type: String, default: 'left' },
		myTextType: { type: String, default: 'text' },
		myValue: { type: String, default: '' },
		myTextDisabled: { type: Boolean, default: false },

		enterCount: { type: Number, default: 0 },
		focusStatus: { type: String, default: 'not focus' },

		img1: { type: String, default: '' },
		img2: { type: String, default: '' },
	},
  methods: {
		toggleTextAlign: function() {
			switch (this.myTextAlign) {
				case 'left':
					this.myTextAlign = 'center';
					break;
				case 'center':
					this.myTextAlign = 'right';
					break;
				case 'right':
					this.myTextAlign = 'left';
					break;
			}
		},
		toggleTextType: function() {
			this.myTextType = this.myTextType == 'text' ? 'password' : 'text';
		},
		setValue: function() {
			this.myValue = 'Value is set';
		},
		toggleDisable: function() {
			this.myTextDisabled = !this.myTextDisabled;
		},
    enterClicked: function() {
      this.enterCount++;
		},
		focusChanged: function(status) {
			this.focusStatus = status ? 'focus' : 'not focus';
		},
		setFocusToInput: function() {
			this.$refs.myInput.setFocus();
		},
		fileChanged: function(e) {
			var reader = new FileReader();
			reader.readAsBinaryString(e[0]);

			reader.onload = r => {
				this.img1 = btoa(r.target.result);
			}
		},
		fileChanged2: function(e) {
			console.log(e[0].type);
			var reader = new FileReader();
			reader.readAsBinaryString(e[0]);

			reader.onload = r => {
				this.img2 = btoa(r.target.result);
			}
		},
		getImage: function(num) {
			if (num == '1') {
				console.log(atob(this.img1));
			} else {
				console.log(this.img2);
			}
		},
		newFileChanged: function(e) {
			var reader = new FileReader();
			reader.readAsBinaryString(e.target.files[0]);

			reader.onload = r => {
				this.img1 = btoa(r.target.result);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.my-input {
	width: 70% !important;
}

.sample-input-main {
	flex-direction: column;
}
</style>